import React from 'react'
import { connect } from 'react-redux';
import { Tabs, Popover } from 'antd';
import { Multiple, Single } from './';
import { clearBetSlip, setTab } from '../../../redux/actions/betSlipActions';
import { SessionStorage, Enums } from '../../../helpers';
import CustomBet from './CustomBet';

const TabPane = Tabs.TabPane;

class BetSlipTab extends React.Component {
	state = {
		multipleDisable: false
	};
	// old logic
	// componentDidUpdate(prevProps, prevState) {
	// 	let tab = SessionStorage.betTab;
	// 	const { setTab, betSlipList } = this.props;
	// 	let multipleDisable = Object.values(betSlipList).filter((bet) =>
	// 	((bet.feed.feedId === Enums.Feed.Casino || bet.feed.feedId === Enums.Feed.SpinAndWin) &&
	// 		bet.sport.sportId === 1)).length > 0;
	// 	if (multipleDisable !== prevState.multipleDisable) {
	// 		this.setState({ multipleDisable: multipleDisable });
	// 		if (multipleDisable && tab == 2) {
	// 			tab = '1';
	// 			setTab('1');
	// 		}
	// 	}
	// }

	// with Lucky Numbers
	componentDidUpdate(prevProps, prevState) {
		let tab = SessionStorage.betTab;
		const { setTab, betSlipList , customBetData } = this.props;
		if(prevProps.customBetData !== customBetData && customBetData && Object.keys(customBetData).length > 0){
			setTab('4');
		}
		if(prevProps.customBetData !== customBetData && prevProps.customBetData && Object.keys(prevProps.customBetData).length > 0 && Object.keys(customBetData).length == 0){
			setTab('2');
		}
		let multipleDisable = Object.values(betSlipList).filter((bet) =>
		((bet.feed.feedId === Enums.Feed.Casino || bet.feed.feedId === Enums.Feed.SpinAndWin || bet.feed.feedId === Enums.Feed.LuckyNumbers))).length > 0;
		if (multipleDisable !== prevState.multipleDisable) {
			this.setState({ multipleDisable: multipleDisable });
			if (multipleDisable && tab == 2) {
				tab = '1';
				setTab('1');
			}
		}
	}

	render() {
		let tab = SessionStorage.betTab;
		const {showNewIcon, newIconImage , customBetData , successMsg}=this.props

		return (
			<div>
				<Tabs className="tabs-betslip" activeKey={tab ? tab.toString() : '2'} defaultActiveKey={tab ? tab.toString() : '2'} onChange={this.props.setTab}>
					<TabPane className="content" tab="Single" key={'1'} >
						<Single {...this.props} />
					</TabPane>
					<TabPane className="content" tab="Multiple" key={'2'} >
						<Multiple {...this.props} />
					</TabPane>
					<TabPane className="content" tab="System" key="3">
						<div className="events">
							<div className="row error-message">
								<div className="text">Coming soon.</div>
							</div>
						</div>
					</TabPane>
					{customBetData && Object.values(customBetData).length > 0 && <TabPane className="content" tab={<div className="new-icon-container">Bet Builder{showNewIcon && <img src={newIconImage} alt="new-icon" className="new-icon"/>}</div>} key="4" onChange={this.props.setTab}>
						<CustomBet {...this.props} />
					</TabPane>}
				</Tabs>
			</div>

		)
	}
}

const mapStateToProps = (state) => {
	return {
		betSlipList: state.betSlip.betSlipList,
		customBetData: state.betSlip.customBetData,
		newIconImage: state.general.configuration.newIconImage,
		showNewIcon: state.general.configuration.showNewIcon,
		successMsg: state.betSlip.successMsg,
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		clearBetSlip: () => {
			dispatch(clearBetSlip())
		},
		setTab: (tab) => {
			dispatch(setTab(tab))
		},

	}
}

export default connect(mapStateToProps, mapDispatchToProps)(BetSlipTab);